module.exports = __webpack_public_path__ + "img/full5-min.72440faf.png";